"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get default () {
        return applyAggregation;
    },
    get validateAggregationColType () {
        return validateAggregationColType;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _pg = require("~/db/aggregations/pg");
const _mysql2 = require("~/db/aggregations/mysql2");
const _sqlite3 = require("~/db/aggregations/sqlite3");
const _getColumnNameQuery = require("~/db/getColumnNameQuery");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const validateAggregationColType = (context, column, aggregation, throwError = true)=>{
    var _column_colOptions;
    const agg = (0, _nocodbsdk.getAvailableAggregations)(column.uidt, (_column_colOptions = column.colOptions) == null ? void 0 : _column_colOptions.parsed_tree);
    if (!agg.includes(aggregation)) {
        if (!throwError) {
            return false;
        }
        _catchError.NcError.get(context).badRequest(`Aggregation ${aggregation} is not available for column type ${column.uidt}`);
    }
    if (Object.values(_nocodbsdk.BooleanAggregations).includes(aggregation)) {
        return 'boolean';
    }
    if (Object.values(_nocodbsdk.CommonAggregations).includes(aggregation)) {
        return 'common';
    }
    if (Object.values(_nocodbsdk.DateAggregations).includes(aggregation)) {
        return 'date';
    }
    if (Object.values(_nocodbsdk.NumericalAggregations).includes(aggregation)) {
        return 'numerical';
    }
    if (Object.values(_nocodbsdk.AttachmentAggregations).includes(aggregation)) {
        return 'attachment';
    }
    return 'unknown';
};
async function applyAggregation({ baseModelSqlv2, aggregation, column, alias }) {
    var _column_colOptions_parsed_tree, _column_colOptions;
    if (!aggregation || !column) {
        return;
    }
    const { context, dbDriver: knex } = baseModelSqlv2;
    /*
  All aggregations are not available for all UITypes. We validate the column type
  and the aggregation type to make sure that the aggregation is available for the column type.
  We also return the type of aggregation that has to be applied on the column.
  The return value can be one of the following:
  - common       - common aggregations like count, count empty, count filled, count unique, etc.
  - numerical    - numerical aggregations like sum, avg, min, max, etc.
  - boolean      - boolean aggregations like checked, unchecked, percent checked, percent unchecked, etc.
  - date         - date aggregations like earliest date, latest date, date range, month range, etc.
  - attachment   - attachment aggregations like attachment size.
  - unknown      - if the aggregation is not supported yet
  */ const aggType = validateAggregationColType(context, column, aggregation);
    if (aggType === false) {
        _catchError.NcError.get(context).notImplemented(`Aggregation ${aggregation} is not implemented yet`);
        return;
    }
    // If the aggregation is not available for the column type, we throw an error.
    if (aggType === 'unknown') {
        _catchError.NcError.get(context).notImplemented(`Aggregation ${aggregation} is not implemented yet`);
        return;
    }
    // If the column is a barcode or qr code column, we fetch the column that the virtual column refers to.
    if (column.uidt === _nocodbsdk.UITypes.Barcode || column.uidt === _nocodbsdk.UITypes.QrCode) {
        column = new _models.Column(_extends({}, await column.getColOptions(context).then((col)=>col.getValueColumn(context)), {
            id: column.id
        }));
    }
    /* The following column types require special handling:
   * - Links
   * - Rollup
   * - Formula
   * - Lookup
   * - LinkToAnotherRecord
   * These column types require special handling because they are virtual columns and do not have a direct column name.
   * We generate the select query for these columns and use the generated query.
   * */ const column_name_query = (await (0, _getColumnNameQuery.getColumnNameQuery)({
        baseModelSqlv2,
        column,
        context
    })).builder;
    const parsedFormulaType = (_column_colOptions = column.colOptions) == null ? void 0 : (_column_colOptions_parsed_tree = _column_colOptions.parsed_tree) == null ? void 0 : _column_colOptions_parsed_tree.dataType;
    if (knex.client.config.client === 'pg') {
        return (0, _pg.genPgAggregateQuery)({
            column,
            baseModelSqlv2,
            aggregation,
            column_query: column_name_query,
            parsedFormulaType,
            aggType,
            alias: alias
        });
    } else if ([
        'mysql',
        'mysql2'
    ].includes(knex.client.config.client)) {
        return (0, _mysql2.genMysql2AggregatedQuery)({
            column,
            baseModelSqlv2,
            aggregation,
            column_query: column_name_query,
            parsedFormulaType,
            aggType,
            alias: alias
        });
    } else if (knex.client.config.client === 'sqlite3') {
        return (0, _sqlite3.genSqlite3AggregateQuery)({
            column,
            baseModelSqlv2,
            aggregation,
            column_query: column_name_query,
            parsedFormulaType,
            aggType,
            alias: alias
        });
    } else {
        _catchError.NcError.get(context).notImplemented(`Aggregation is not implemented for ${knex.client.config.client} yet.`);
    }
}
